import { useState, useEffect } from 'react';
import parsePhoneNumber from 'libphonenumber-js';
import { defaultImage } from '../../settings/config';

interface ProfileProps {
  child: any;
  parent: any;
}

function Profile({ child, parent }: ProfileProps) {
  const [parentPhone, setParentPhone] = useState<string | null>(null);

  useEffect(() => {
    const parent_phone = parent.phone_number ? parsePhoneNumber(parent.phone_number, 'US') : null;
    if (parent_phone) {
      setParentPhone(parent_phone.number as string);
    }
  }, [parent]);

  return (
    <div className="max-w-lg mx-auto p-4 bg-background">
      <h1 className="text-center mb-4">
        <a href="https://www.planaplay.com" className="text-accent hover:text-accent/80 no-underline text-2xl font-bold transition-colors">
          Plan-A-Play
        </a>
      </h1>

      <div className="border border-border rounded-2xl overflow-hidden bg-card shadow-soft-sm mb-4">
        <img
          alt={`${child.first_name} profile`}
          src={child.image_url || defaultImage}
          className="w-full object-cover"
          style={{ maxHeight: '400px' }}
        />
        <div className="p-4 border-b border-border">
          <h2 className="font-semibold text-xl text-card-foreground">{child.first_name}</h2>
        </div>
        <div className="p-4">
          {child.bio && <p className="text-muted-foreground">{child.bio}</p>}
          {(child.favorite_activities && child.favorite_activities.length > 0) ? (
            <p className="mt-2 text-foreground">
              <span className="font-semibold">Favorite Activities:</span>{' '}
              {child.favorite_activities}
            </p>
          ) : null}
        </div>
      </div>

      <div className="border border-border rounded-2xl overflow-hidden bg-card shadow-soft-sm">
        <div className="p-4 border-b border-border">
          <p className="text-2xs font-semibold uppercase tracking-widest text-muted-foreground">Parent</p>
          <h2 className="font-semibold text-lg mt-1 text-card-foreground">{parent.full_name}</h2>
        </div>
        <div className="p-4">
          {parentPhone ? (
            <p>
              <a href={"tel:" + parentPhone} className="text-accent hover:text-accent/80 hover:underline transition-colors">
                {parent.phone_number}
              </a>
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default Profile;
